import React from 'react'
import { Platform } from 'react-native'

import FacebookSVG from 'app/assets/icons/auth-facebook.svg'
import Button from 'app/components/base/Button'
import { IS_ANDROID } from 'app/utils/constants/env.constants'

interface FacebookRenderButtonProps {
  onClick: () => void
  disabled?: boolean
}

const FacebookRenderButton: RFC<FacebookRenderButtonProps> = ({
  onClick,
  disabled
}) => {
  return (
    <Button
      sx={{
        textAlign: 'center',
        flex: 1
      }}
      {...Platform.select({
        android: {
          icon: () => <FacebookSVG />
        }
      })}
      variant="outlined"
      fullWidth
      onClick={onClick}
      disabled={disabled}
      {...Platform.select({
        native: {
          labelSx: {
            height: 18
          }
        }
      })}
    >
      {!IS_ANDROID && <FacebookSVG />}
    </Button>
  )
}

export default FacebookRenderButton
